import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SendIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { mockRequisitions } from '../data/mockData';
import { Requisition } from '../types';
export function IssueList() {
  const navigate = useNavigate();
  // Only show approved requisitions
  const approvedRequisitions = mockRequisitions.filter(r => r.status === 'Approved');
  const columns: Column<Requisition>[] = [{
    key: 'reqNo',
    label: 'REQ No',
    render: r => <span className="font-medium text-amber-600" data-id="element-1210">{r.reqNo}</span>
  }, {
    key: 'department',
    label: 'Department'
  }, {
    key: 'requestedBy',
    label: 'Requested By'
  }, {
    key: 'requiredDate',
    label: 'Required Date'
  }, {
    key: 'totalItems',
    label: 'Total Items'
  }, {
    key: 'status',
    label: 'Status',
    render: r => <StatusBadge status={r.status} data-id="element-1211" />
  }];
  return <div className="space-y-6 h-full flex flex-col" data-id="element-1212">
      <div className="flex items-center gap-3" data-id="element-1213">
        <div className="p-3 bg-amber-100 rounded-lg" data-id="element-1214">
          <SendIcon className="h-6 w-6 text-amber-600" data-id="element-1215" />
        </div>
        <div data-id="element-1216">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1217">Issue</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1218">
            Issue inventory against approved requisitions.
          </p>
        </div>
      </div>

      <div className="flex-1" data-id="element-1219">
        <DataTable columns={columns} data={approvedRequisitions} keyExtractor={item => item.id} searchPlaceholder="Search approved requisitions..." onRowClick={item => navigate(`/issue/${item.id}`)} actions={item => <div className="flex space-x-3 justify-end" data-id="element-1221">
              <button onClick={e => {
          e.stopPropagation();
          navigate(`/issue/${item.id}`);
        }} className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded text-amber-700 bg-amber-100 hover:bg-amber-200" data-id="element-1222">
                Issue
              </button>
            </div>} data-id="element-1220" />
      </div>
    </div>;
}